import { Buffer } from 'buffer';

/**
 * Decodes a Base64 encoded string to UTF-8.
 *
 * @param {string} key - The string to decode.
 * @returns {string | undefined} - The decoded UTF-8 string, or undefined if the key is invalid.
 */
export const decodeBase64 = (key: string) => {
  if (typeof key === 'undefined' || key === null) {
    return;
  }
  return Buffer.from(key, 'base64').toString('utf8');
};

/**
 * Encodes a string or Buffer to Base64.
 *
 * @param {string | Buffer} key - The data to encode.
 * @returns {string | undefined} - The Base64 encoded string, or undefined if the key is invalid.
 */
export const encodeBase64 = (key: string | Buffer) => {
  if (typeof key === 'undefined' || key === null) {
    return;
  }

  if (typeof key === 'string') {
    return Buffer.from(key, 'utf8').toString('base64');
  } else {
    return Buffer.from(key).toString('base64');
  }
};

/**
 * Encodes data as URL-safe Base64.
 *
 * @param {Buffer | string} unencoded - The data to encode.
 * @returns {string} - The URL-safe Base64 encoded string.
 */
export const urlSafeBase64Encode = (unencoded: Buffer | string): string => {
  const encoded = encodeBase64(unencoded);
  return encoded.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
};

/**
 * Decodes a URL-safe Base64 encoded string.
 *
 * @param {string} encoded - The Base64 encoded data.
 * @returns {string} - The decoded string.
 */
export const urlSafeBase64Decode = (encoded: string): string => {
  let encodedReplaced = encoded.replace('-', '+').replace('_', '/');
  while (encodedReplaced.length % 4) {
    encodedReplaced += '=';
  }
  return decodeBase64(encodedReplaced);
};
